/**
 * Visit counts by Plausible (Daniel, 2026-10-17): cookieless, no personal data, on the production
 * domain only, so tests, branch previews and local runs are not counted. The privacy page says
 * what it collects. This is Plausible's own snippet, written out so it passes the linter: a queue
 * that holds calls until the script has loaded, `init` with its options, then the script.
 */
const SCRIPT = "https://plausible.io/js/pa-wgk9gZPQvmtd5XTtjZhkl.js";

type Plausible = ((...args: unknown[]) => void) & {
  q?: unknown[][];
  o?: object;
  init?: (options?: object) => void;
};

export function startAnalytics(): void {
  if (!/(^|\.)mistsweeper\.com$/.test(location.hostname)) return;
  const w = window as unknown as { plausible?: Plausible };
  if (!w.plausible) {
    const stub: Plausible = (...args: unknown[]) => {
      stub.q = stub.q ?? [];
      stub.q.push(args);
    };
    stub.init = (options) => {
      stub.o = options ?? {};
    };
    w.plausible = stub;
  }
  w.plausible.init?.();
  const script = document.createElement("script");
  script.async = true;
  script.src = SCRIPT;
  document.head.append(script);
}
